module.exports = {
  siteTitle: 'Yashints',
  logo: 'https://yashints.dev/favicon/logo-48.png',
  siteCover: 'images/logo.png',
  siteLogo: 'images/code.png',
  author: 'Yas Adel Mehraban (Yashints)',
  url: 'https://yashints.dev',
  rootUrl: 'yashints.dev',
  title: 'Yashints | Blog',
  legalName: 'Yaser Adel Mehraban',
  shortName: 'Yas',
  siteGithubRepo: 'https://github.com/yashints/yashints.dev',
  authorDescription:
    'GenAI guru and Principal Software Engineer at Atlassian, making the dev loop calmer and Jira a little smarter.',
  socialLinks: {
    twitter: 'http://www.twitter.com/yashints',
    github: 'https://github.com/yashints',
    linkedIn: 'https://www.linkedin.com/in/yashints',
    youtube: '',
    google: '',
    email: 'mailto:me@yashints.dev',
  },
  googleAnalyticsID: 'G-KZ55P1V3M1',
  themeColor: '#00c6ff',
  backgroundColor: '#00c6ff',
  siteRss: '/rss',
  social: {
    twitter: 'yashints',
    linkedIn: 'yashints',
    github: 'yashints',
  },
  address: {
    city: 'Melbourne',
    region: 'VIC',
    country: 'Australia',
    zipCode: '3000',
  },
  contact: {
    email: 'me@yashints.dev',
  },
  foundingDate: '2012',
};
